export default __webpack_public_path__ + "static/media/2Blog.7b8e7f34.png";